import "../CSS/formAgregarEvento.css";
import IncrementadorNum from "./IncrementadorNum";

import React, { useRef, useEffect, useState, Fragment } from "react";
import NavBar from "./NavBar";
import { storage } from "../FirebaseConfig/firebase";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import LinearProgress from "@mui/material/LinearProgress";
import { db } from "../FirebaseConfig/firebase";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import { getDoc, setDoc, doc } from "firebase/firestore";
import { useNavigate, useParams, Link } from "react-router-dom";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import moment from "moment-timezone";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import dayjs from "dayjs";

const MySwal = withReactContent(Swal);

function AgregarComunicado() {
  const navigate = useNavigate();

  const handleChange = (newValue) => {
    console.log(dayjs(newValue).format("YYYY-MM-DD HH:mm"));

    setFecha(newValue);
    setFechaString(dayjs(newValue).format("YYYY-MM-DD HH:mm"));
  };

  const { id } = useParams();
  const [maxAsientos, setMaxAsientos] = useState("0");
  const [estado, setEstado] = React.useState("");
  const [salon, setSalon] = React.useState("");
  const [nombre, setNombre] = React.useState("");
  const [fecha, setFecha] = React.useState("");
  const [descripcion, setDescripcion] = React.useState("");
  const [urlImagen, setUrlImage] = useState("");
  const [pbVisible, setpbVisible] = useState(false);
  const [tipoEvento, setTipoEvento] = useState("");
  const [fechaString, setFechaString] = useState("");
  const [isSalon, setIsSalon] = useState(false);
  const [datosCargados, setDatosCargados] = useState(false); // MOSTRAR BARRA DE CARGA

  const handleChangeSa = (event) => {
    setSalon(event.target.value);
  };
  const handleChangeEs = (event) => {
    setEstado(event.target.value);
  };
  const handleChangeTE = (event) => {
    setTipoEvento(event.target.value);
  };
  //Funcion para mostrar detalles del evento
  const getEventoById = async (id) => {
    const cupon = await getDoc(doc(db, "EVENTOS", id));
    if (cupon) {
      setNombre(cupon.data().nombre);
      setDescripcion(cupon.data().descripcion);
      setUrlImage(cupon.data().urlImagen);
      setEstado(cupon.data().estado);
      setSalon(cupon.data().salon);

      setFecha(dayjs(cupon.data().fecha));

      //setFecha((new Date(cupon.data().fecha)).toISOString().substring(0, 16));
      setMaxAsientos(cupon.data().maxAsientos);
      setTipoEvento(cupon.data().tipoEvento);
      if (cupon.data().salon == "Salon de eventos") {
        setIsSalon(true);
      } else {
        setIsSalon(false);
      }
    } else {
      console.log("no existe");
    }
    setDatosCargados(true);
  };
  const itemCupones = () => {
    navigate(`../panelAdmin/eventos/${id}/cupones`);
  };
  const validarFormulario = (e) => {
    if (
      nombre == "" ||
      descripcion == "" ||
      salon == "" ||
      fecha == "" ||
      estado == ""
    ) {
      MySwal.fire("", "Llenar todos los campos", "error");
    } else {
      if (urlImagen == "") {
        MySwal.fire("", "Subir imagen ", "error");
      } else {
        store(e);
      }
    }
  };
  const archivoHandler = (e) => {
    const archivo = e.target.files[0];
    setpbVisible(true);
    var today = new Date();
    var prefijoImagen =
      today.getDate().toString() +
      today.getHours().toString() +
      today.getMinutes().toString() +
      today.getSeconds().toString();

    const storageRef = ref(
      storage,
      "imagenesEventos/" + prefijoImagen + archivo.name
    );

    uploadBytes(storageRef, archivo).then((snapshot) => {
      setpbVisible(false);

      const storage = getStorage();
      getDownloadURL(
        ref(storage, "imagenesEventos/" + prefijoImagen + archivo.name)
      )
        .then((url) => {
          setUrlImage(url);
          console.log("URL " + url);
          const xhr = new XMLHttpRequest();
          xhr.responseType = "blob";
          xhr.onload = (event) => {
            setpbVisible(false);

            const blob = xhr.response;
          };
          xhr.open("GET", url);
          xhr.send();
          // Or inserted into an <img> element
          const img = document.getElementById("imagenTienda");
          img.setAttribute("src", url);
        })
        .catch((error) => {
          console.log("error " + error);
        });
    });
  };

  const store = async (e) => {
    e.preventDefault();

    MySwal.fire({
      title: isSalon
        ? "¿Guardar cambios? Después podrá editar las mesas"
        : "Editar evento?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: isSalon ? "Si, Guardar" : "Si, Editar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        update(e);
        if (!isSalon) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Evento editado",
            showConfirmButton: false,
            timer: 1500,
          });
        }

        if (isSalon) {
          navigate(`../panelAdmin/eventos/${id}/editarEvento/`);
        } else {
          navigate("../panelCDA/eventos");
        }
      }
    });
  };

  const update = async (e) => {
    e.preventDefault();
    console.log(id);
    const evento = doc(db, "EVENTOS", id);
    const data = {
      descripcion: descripcion,
      estado: estado,
      urlImagen: urlImagen,
      nombre: nombre,
      salon: salon,
      fecha: dayjs(fecha).format("YYYY-MM-DD HH:mm"),
      maxAsientos: maxAsientos,
      tipoEvento: tipoEvento,
    };
    await setDoc(evento, data);
  };

  //cerrar agregar evento
  const cerrar = () => {
    navigate("../panelCDA/eventos");
  };
  useEffect(() => {
    getEventoById(id);
  }, []);
  if (!datosCargados) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          margin: "0px auto",
          textAlign: "center",
          height: "100vh",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div style={{ verticalAlign: "middle", display: "block" }}>
          <div>
            <img
              style={{ height: "300px" }}
              src={require(`../img/docucargando.gif`)}
              alt="esperando"
            />
          </div>
        </div>
      </div>
    );
  }

  return (
    <Fragment>
      <NavBar
        titulo="Editar evento"
        imagen="cerrar"
        logoTitulo="eventos"
        cerrar={cerrar}
      ></NavBar>
      <div>
        <div className="grid-container">
          <div className="grid-item">
            <div className="divImagen">
              <div className="image-upload">
                <label htmlFor="file-input">
                  <img
                    id="imagenTienda"
                    src={urlImagen}
                    alt="logo-titulo"
                    className="imagenEmpresa"
                  />
                </label>
                <input
                  className="btnAgrearImagenEvento"
                  id="file-input"
                  accept="image/png, image/jpeg, image/jpg"
                  type="file"
                  onChange={archivoHandler}
                />
              </div>
              {pbVisible ? (
                <LinearProgress color="success" style={{ marginBottom: 20 }} />
              ) : null}
            </div>

            <div className="formNumber">
              <Box sx={{ width: 300 }}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Salon</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={salon}
                    label="Salon"
                    onChange={handleChangeSa}
                  >
                    <MenuItem value={"Auditorio Paulet"}>
                      Auditorio Paulet
                    </MenuItem>
                    <MenuItem value={"Salon de eventos"}>
                      Salon de eventos
                    </MenuItem>
                  </Select>
                </FormControl>
              </Box>
            </div>

            <div className="formNumber">
              <Box sx={{ width: 300 }}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Estado</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={estado}
                    label="Estado"
                    onChange={handleChangeEs}
                  >
                    <MenuItem value={"Activo"}>Activo</MenuItem>
                    <MenuItem value={"Inactivo"}>Inactivo</MenuItem>
                  </Select>
                </FormControl>
              </Box>
            </div>
            <div className="formNumber">
              <Box sx={{ width: 300 }}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    Tipo de evento
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={tipoEvento}
                    label="tipo de evento"
                    onChange={handleChangeTE}
                  >
                    {salon == "Auditorio Paulet" ? (
                      <MenuItem value={"Gratuito"}>Gratuito</MenuItem>
                    ) : null}
                    {salon == "Auditorio Paulet" ? (
                      <MenuItem value={"Pago"}>Pago</MenuItem>
                    ) : (
                      <MenuItem value={"Pago (con comida)"}>
                        Pago (con comida)
                      </MenuItem>
                    )}

                    {salon == "Auditorio Paulet" ? (
                      <MenuItem value={"Mixto"}>Mixto</MenuItem>
                    ) : (
                      <MenuItem value={"Pago (sin comida)"}>
                        Pago (sin comida)
                      </MenuItem>
                    )}

                    {salon == "Auditorio Paulet" ? (
                      <MenuItem value={"Colegiatura"}>Colegiatura</MenuItem>
                    ) : null}
                    {salon == "Auditorio Paulet" ? (
                      <MenuItem value={"ColegiaturaInvitados"}>Colegiatura – Invitados</MenuItem>
                    ) : null}
                  </Select>
                </FormControl>
              </Box>
            </div>
          </div>
          <div className="grid-item">
            <div className="formulario-derecha-contenedor">
              <div className="formulario-derecha-contenido">
                <div className="form-derecha">
                  <form action="/" className="form">
                    <label className="label">Nombre del evento</label>
                    <textarea
                      type="text"
                      id="descripcion"
                      maxLength="200"
                      placeholder="Máximo 200 caracteres."
                      className="input input-descripcion"
                      value={nombre}
                      onChange={(e) => setNombre(e.target.value)}
                    />
                    <label className="label">Descripción del evento</label>
                    <textarea
                      style={{ height: "200px" }}
                      type="text"
                      id="descripcion"
                      maxLength="200"
                      placeholder="Máximo 200 caracteres."
                      className="input input-descripcion"
                      value={descripcion}
                      onChange={(e) => setDescripcion(e.target.value)}
                    />
                  </form>

                  <label className="label">Fecha del evento</label>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <Stack component="form" noValidate spacing={3}>
                      <DateTimePicker
                        value={fecha}
                        onChange={handleChange}
                        renderInput={(params) => <TextField {...params} />}
                      />
                    </Stack>
                  </LocalizationProvider>
                </div>
                <div style={{ width: "350px" }}></div>

                {isSalon ? null : (
                  <div className="formNumber">
                    <label className="label" style={{ marginRight: "40px" }}>
                      Asientos permitidos
                    </label>
                    <IncrementadorNum
                      style={{ margin: "30px" }}
                      contador={maxAsientos}
                      setContador={setMaxAsientos}
                    ></IncrementadorNum>
                  </div>
                )}
                <div className="agregarEvento" style={{ paddingTop: "20px" }}>
                  <input
                    type="submit"
                    value={
                      isSalon ? "Editar Salón del evento" : "Editar Evento"
                    }
                    onClick={validarFormulario}
                    className="btnAgregarComunicado"
                  />
                </div>
                {isSalon ? (
                  <div className="agregarEvento">
                    <input
                      style={{ background: "#F6F32B" }}
                      type="submit"
                      value={"CUPONES"}
                      onClick={itemCupones}
                      className="btnAgregarComunicado"
                    />
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default AgregarComunicado;
